import { Reveal } from "./Reveal";
import { Download } from "lucide-react";
import { toast } from "sonner";

const PORTRAIT =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_prostho-excellence-1/artifacts/3lowsctu_IMG-20260727-WA0015.jpg";

const CREDENTIALS = [
  { k: "MDS", v: "Prosthodontics & Crown-Bridge" },
  { k: "Oral Implantology", v: "Fixed · Removable · Implant" },
  { k: "IPS", v: "Life Member — Indian Prosthodontic Society" },
  { k: "Based in", v: "Kalyan West, Maharashtra" },
];

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const About = () => {
  const handleDownload = () => {
    toast.success("Preparing your clinical portfolio…");
    window.open(`${API}/portfolio/download`, "_blank");
  };

  return (
    <section id="about" data-testid="about-section" className="bg-ivory py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Portrait */}
        <Reveal className="lg:col-span-5 relative">
          <div className="relative">
            <div className="absolute -top-5 -left-5 w-full h-full border border-champagne/50" />
            <img
              src={PORTRAIT}
              alt="Dr. Priya H. Mishra"
              data-testid="about-portrait"
              className="relative w-full h-[440px] sm:h-[560px] object-cover object-top"
            />
          </div>
        </Reveal>

        {/* Copy */}
        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-champagne-dark text-xs uppercase tracking-[0.3em] mb-6">
              About the Practitioner
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-emerald leading-[1.05]">
              A meticulous approach to modern prosthodontics.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base md:text-lg text-emerald/70 leading-relaxed max-w-2xl">
              Dr. Priya H. Mishra is an MDS-qualified Prosthodontist and Oral Implantologist with
              comprehensive postgraduate clinical training and current hospital-based consulting
              experience. She is skilled in fixed, removable and implant-supported prosthodontics,
              maxillofacial prosthetics, digital CAD/CAM workflows and sleep-related oral appliance
              therapy.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-5 text-base md:text-lg text-emerald/70 leading-relaxed max-w-2xl">
              Her clinical practice serves the Kalyan-Dombivali, Thane and Mulund regions,
              where she works in close collaboration with referring dentists and a trusted
              network of consulting clinicians. Complex full-mouth, implant and aesthetic
              rehabilitation cases are planned jointly and delivered through associated
              clinical and hospital settings where required.
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-12 grid grid-cols-2 gap-y-8 gap-x-6 max-w-xl">
              {CREDENTIALS.map((c) => (
                <div key={c.k} className="border-t border-emerald/15 pt-4">
                  <p className="font-display text-xl text-emerald">{c.k}</p>
                  <p className="text-sm text-emerald/60 mt-1">{c.v}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.25}>
            <button
              data-testid="about-download-portfolio-btn"
              onClick={handleDownload}
              className="mt-12 inline-flex items-center gap-3 border border-champagne text-emerald px-8 py-4 uppercase tracking-[0.15em] text-sm hover:bg-champagne transition-colors duration-300"
            >
              <Download size={16} />
              Download Clinical Portfolio
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
